export default (arg) => arg !== undefined && arg !== null
